// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".b8xvupkV8x5zs0 {\n  font-size: 14px;\n  line-height: 20px;\n}\n.r6VUFUtVqfLP0f {\n  text-decoration: underline;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"messaging": "b8xvupkV8x5zs0",
	"ctaLink": "r6VUFUtVqfLP0f"
};
export default ___CSS_LOADER_EXPORT___;
